<div class="stock-take-general-settings-container no-select">



  <div class="widget-div">



    @if (canOverridesBeViewed) {

      <app-shared-widget-container-component>

        <div title class="widget-div-heading">

          <app-display-icon

            [tooltip]="canOverridesBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"

            [icon]="canOverridesBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">

          </app-display-icon>

          <div>Defaults</div>

          <app-display-icon

            [tooltip]="'Controls default Del-Col and max item limits when creating stock takes or schedules for this store.'"

            [icon]="icons.infoSlabCircleOutline"

            [colour]="iconColours.secondary">

          </app-display-icon>

        </div>

        <div block>

          <form>

            <div class="form-column">

              <div class="form-control-div toggle-item">

                <div class="toggle-copy">

                  <div class="label">Include Del-Col by default</div>

                  <div class="hint">When off, new stock takes and schedule runs start with Del-Col excluded from variance. Existing stock takes are unchanged.</div>

                </div>

                <app-switch-ui

                  (checkedChange)="onToggleIncludeDelColDefault($event)"

                  [ariaLabel]="'stock-take-include-delcol-default'"

                  [checked]="includeDelColDefault"

                  [disabled]="!canOverridesBeEdited"

                  [size]="0.7">

                </app-switch-ui>

              </div>



              <div class="form-control-div number-item">

                <div class="toggle-copy">

                  <label class="label" for="stock-take-default-max-item-limit">Default max items</label>

                  <div class="hint">

                    Used when creating stock takes (filter / uncounted) and new schedules. App default is {{ appDefaultMaxItemLimit }}; hard maximum is {{ baseItemLimitMax }}.

                  </div>

                </div>

                <input

                  id="stock-take-default-max-item-limit"

                  class="number-input"

                  type="number"

                  min="1"

                  [max]="baseItemLimitMax"

                  [value]="defaultMaxItemLimit"

                  [disabled]="!canOverridesBeEdited"

                  (input)="onDefaultMaxItemLimitInput($event)" />

              </div>

            </div>

          </form>

        </div>

        <div actions class="widget-actions">

          @if (hasOverridesBeenEdited) {

            <button

              type="button"

              class="action-button"

              [disabled]="canOverridesBeEdited === false"

              (click)="onRevertForm('overrides')">

              <app-display-icon

                [colour]="canOverridesBeEdited === false ? iconColours.disabled : iconColours.secondary"

                [tooltip]="tooltips.undoChanges"

                [icon]="icons.undo">

              </app-display-icon>

            </button>

          }

          @if (canOverridesBeSubmitted) {

            <button

              type="button"

              class="action-button"

              [disabled]="isOverridesSubmitDisabled"

              (click)="onSubmitForm('overrides')">

              <app-display-icon

                [colour]="isOverridesSubmitDisabled ? iconColours.disabled : iconColours.secondary"

                [tooltip]="tooltips.saveChanges"

                [icon]="icons.contentSaveOutline">

              </app-display-icon>

            </button>

          }

        </div>

      </app-shared-widget-container-component>

    }



  </div>



  <div class="ups-container-action-bar widget-actions">

    <button

      [disabled]="!haveAnyEditsBeenMade"

      type="button"

      class="action-button"

      (click)="onRevertForm('all')">

      <app-display-icon

        [colour]="iconColours.secondary"

        [tooltip]="tooltips.undoAllChanges"

        [icon]="icons.undo">

      </app-display-icon>

      Undo Changes

    </button>

    <button

      [disabled]="isSaveAllDisabled"

      type="button"

      class="action-button"

      (click)="onSubmitForm('all')">

      <app-display-icon

        [colour]="iconColours.secondary"

        [tooltip]="tooltips.saveAllChanges"

        [icon]="icons.contentSaveOutline">

      </app-display-icon>

      Save All

    </button>

  </div>



</div>

